import { Check, X, Minus } from 'lucide-react'
import { Chip } from './Chip'
import type { SelectedApplication } from '../../utils/interviews'

type GateDef = {
  key: keyof SelectedApplication
  label: string
}

const GATES: GateDef[] = [
  { key: 'gate_k_has_uber_profile', label: 'Uber profile' },
  { key: 'gate_m_rating_valid', label: 'Rating valid' },
  { key: 'gate_n_pro_level_valid', label: 'Pro level valid' },
  { key: 'gate_q_province_gauteng', label: 'Gauteng province' },
  { key: 'gate_r_town_nonblank', label: 'Town provided' },
]

export function GateChips({ app }: { app: SelectedApplication }) {
  const drivingNow = app.contrib_l_currently_driving_uber === true
  return (
    <div className="flex flex-wrap gap-1.5">
      {GATES.map((g) => {
        const pass = app[g.key] === true
        return (
          <Chip
            key={String(g.key)}
            tone={pass ? 'green' : 'red'}
            icon={pass ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />}
          >
            {g.label}
          </Chip>
        )
      })}
      <Chip tone="neutral" icon={<Minus className="h-3 w-3" />}>
        {drivingNow ? 'Currently driving Uber' : 'Not currently driving Uber'}
      </Chip>
    </div>
  )
}
